const STORAGE_KEY = 'npcPreviewReturnUrl';

/** Accept only a same-site path under /preview/. Reject open redirects. */
export function validatePreviewReturnUrl(value: string | null | undefined): string | null {
    if (!value) {
        return null;
    }

    let decoded = value.trim();
    try {
        decoded = decodeURIComponent(decoded);
    } catch {
        return null;
    }

    if (!decoded.startsWith('/preview/')) {
        return null;
    }
    if (decoded.startsWith('//') || decoded.includes('\\') || decoded.includes('://')) {
        return null;
    }
    for (let i = 0; i < decoded.length; i++) {
        if (decoded.charCodeAt(i) < 32) {
            return null;
        }
    }

    const path = decoded.split('?')[0].split('#')[0];
    if (!path.startsWith('/preview/') || path.split('/').includes('..')) {
        return null;
    }

    return decoded;
}

export function rememberPreviewReturnUrl(value: string | null | undefined): void {
    const valid = validatePreviewReturnUrl(value);
    if (!valid || typeof sessionStorage === 'undefined') {
        return;
    }
    sessionStorage.setItem(STORAGE_KEY, valid);
}

export function consumePreviewReturnUrl(): string | null {
    if (typeof sessionStorage === 'undefined') {
        return null;
    }
    const stored = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return validatePreviewReturnUrl(stored);
}

/**
 * Preview is hosted on the Admin origin at /preview/. Stay on the current origin
 * so a locally persisted support session is visible in the new tab. Local admin
 * (port 4200) still targets the playground server when that base is a different origin.
 */
export function previewAppUrl(options: {
    pageOrigin: string;
    configuredBase: string;
    schoolId: string;
    sessionId?: string;
    supportLogin?: boolean;
}): string {
    const configured = new URL(options.configuredBase, options.pageOrigin);
    const useConfiguredOrigin = configured.origin !== options.pageOrigin
        && configured.hostname === 'localhost';
    const origin = useConfiguredOrigin ? configured.origin : options.pageOrigin;
    const url = new URL(`/preview/app/${encodeURIComponent(options.schoolId)}`, origin);
    if (options.sessionId) {
        url.searchParams.set('sessionId', options.sessionId);
    }
    if (options.supportLogin) {
        url.searchParams.set('login', 'support');
    }
    return url.toString();
}
